const fetchSuccess = () => ({
  type: "FETCH_SUCCESS",
});

export default fetchSuccess;
